module.exports = __webpack_public_path__ + "static/media/logo_slam.a61fbc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/slam/logo_slam.png
// module id = 1661
// module chunks = 0